<script>
	import { onMount, createEventDispatcher } from 'svelte'
	import { Link, navigate } from 'svelte-routing'

	import axios from 'axios'
	import wait from '../../libs/wait'

	import FadeinFX from '../../components/FX/FadeinFx.svelte'
	// import SlideinFX from '../../components/FX/SlideinFX.svelte';
	import AdminLayout from '../../layouts/AdminLayout.svelte'
	// import Header from '../../components/Header/Header.svelte';
	import userStore from '../../stores/user'

	export let id

	const dispatch = createEventDispatcher()

	let screenReady = false
	let model = null

	const openOldApp = () => {
		window.open(`http://easymanager.work:8080/easycrm/worker.php/dashboard/index/${$userStore.username}`)
	}

	onMount(() => {
		console.log('id', id)
		// dispatch ('app-event', { id: 'background', value: true });
		screenReady = true
		// axios.get ('/api/categories/olist')
		//     .then (result => {
		//         model = result.data.categories;
		//         dispatch ('app-event', { id: 'background', value: false });
		//         screenReady = true
		//     }).catch (e => {
		//         dispatch ('app-event', { id: 'app-error', error: e });
		//         screenReady = true
		//     })
	})
</script>

<AdminLayout>
	<div class="page-pad avoid-selection">
		{#if screenReady}
			<!-- <FadeinFX delay={600} delayOut={0}>
                <button class="btn btn-sm btn-primary" on:click={openOldApp}>App Vetusta</button>
            </FadeinFX> -->
		{/if}
	</div>
</AdminLayout>

<style>
</style>
